import { mapState } from 'pinia';
import { useSidebarStore } from '../../../store/useSidebarStore.js';

const GRID_COLUMNS = 12;
const RIGHT_SIDEBAR_COLUMN_SPAN = 2;

function getSidebarSpacerSpan(isCollapsed, isSmallDesktop) {
  if (isCollapsed || isSmallDesktop) {
    return 1;
  }
  return 2;
}

export default {
  computed: {
    ...mapState(useSidebarStore, ['isCollapsed']),
    siteLayoutSidebarSpacerSpan() {
      return getSidebarSpacerSpan(this.isCollapsed, this.isSmallDesktop);
    },
    siteLayoutMainContentSpan() {
      if (this.isMobile) {
        return GRID_COLUMNS;
      }
      return GRID_COLUMNS - this.siteLayoutSidebarSpacerSpan;
    },
    siteLayoutMainContentWithSidebarSpan() {
      if (this.isMobile) {
        return GRID_COLUMNS;
      }
      return GRID_COLUMNS - this.siteLayoutSidebarSpacerSpan - RIGHT_SIDEBAR_COLUMN_SPAN;
    },
    siteLayoutFeedMainContentSpan() {
      if (this.isMobile) {
        return GRID_COLUMNS;
      }
      return this.isSmallDesktop ? 8 : 7.5;
    },
  },
};
